import { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';
import { SuggestionsService } from '../types/SuggestionsService';
import { getSuggestionsService } from './getSuggestionsService';

export const searchSuggestions: SuggestionsService = (
    userIdentity: string | null,
    queryString: string,
    includeDirectory: boolean,
    clientRequestId?: string | null,
    feedbackManager?: FeedbackManagerState | null,
    currentRecipients?: string[] | null,
    scenario?: string | null
) => {
    const searchService = getSuggestionsService();
    return searchService(
        userIdentity,
        queryString,
        includeDirectory,
        clientRequestId,
        feedbackManager,
        currentRecipients,
        scenario
    );
};
